<template>
  <section>
    <!--<header class="mui-bar mui-bar-nav">-->
      <!--<a class="mui-action-back mui-icon mui-icon-left-nav mui-pull-left"></a>-->
      <!--<h1 class="mui-title">取样履历</h1>-->
    <!--</header>-->
    <div class="mui-content pd-8">
      <div class="title-name">
        <span class="">取样履历</span>
      </div>
      <!--基础信息-->
      <div class="sampling-first" style="margin-top: 15px;">
          <!--第一行-->
          <div class="sampling-first-title">
              <h4  style="padding-left:10px;">基础信息</h4>
          </div>
          <!--第二行内容-->
          <div class="sampling-first-content">
              <!--第1行-->
              <div style="font-size: 15px;">
                  <div class="sampling-first-content-left">
                      <span>外注订单:</span>
                  </div>
                  <div class="flex-8">
                      <span>{{paraInfo.ddh}}</span>
                  </div>
              </div>
              <!--第2行-->
              <div style="font-size: 15px;">
                  <div class="sampling-first-content-left">
                      <span>物料:</span>
                  </div>
                  <div class="flex-8">
                      <span>{{paraInfo.scxtwph+" "+paraInfo.scxtwpmc}}</span>
                  </div>
              </div>
          </div>
      </div>

      <div class="sampling-first" style="border-bottom: 0px;">
          <!--第一行-->
          <div class="sampling-first-title">
              <h4  style="padding-left: 10px;">取样明细</h4>
          </div>
          <!--第二行内容-->
          <div class="sampling-first-content">
            <ul  class="mui-table-view">
              <li class="mui-table-view-cell flex-content" style="display: block;margin-bottom: 10px;"  v-for="(info,i) in sampleList" :id="info.sampleno">
                <div class="mui-slider-right mui-disabled">
                  <a class="mui-btn mui-btn-grey" v-if="info.determinegrade==''"  @tap="updsample(info.sampleno)">修改</a>
                  <a class="mui-btn mui-btn-yellow" v-if="info.determineuserflg=='0'" @tap="determine(info)">判定</a>
                  <a class="mui-btn mui-btn-yellow" v-if="info.determineuserflg=='1'" @tap="determine(info)">查看详情</a>
                  <a class="mui-btn mui-btn-red" v-if="info.determinegrade==''"  @tap="delsample(info.sampleno)">删除</a>
                </div>
                <div class="mui-slider-handle">
                  <div class="mui-table-cell">
                    <!--第一个-->
                    <!-- <div class=""> -->
                      <div class="flex-box">
                        <div class="flex-container">
                            <div class="flex-content-container flex-4">
                                <div class="flex-content-label" style="text-align: left;padding-right: 0px;">取样日期：</div>
                                <div class="flex-content-span flex-1">{{info.sampletime}}</div>
                            </div>
                            <div class="flex-content-container flex-1">
                              <div class="flex-content-label" style="min-width: 0px;text-align: left;padding-right: 0;"></div>
                              <div class="flex-content-span flex-1">No:{{(i+1)}}</div>
                            </div>
                        </div>
                        <div class="flex-container">
                            <div class="flex-content-container flex-4">
                              <div class="flex-content-label" style="text-align: left;min-width:76px;padding-right: 0px;">取样品番：</div>
                              <div class="flex-content-span flex-1">{{info.clothcode}}</div>
                            </div>
                            <div class="flex-content-container flex-3">
                              <div class="flex-content-label" style="text-align: left;min-width: 40px;"></div>
                              <div class="flex-content-span flex-strong flex-1">{{info.determinegrade}}</div>
                            </div>
                        </div>
                        <div class="flex-container">
                            <div class="flex-content-container flex-4">
                                <div class="flex-content-label" style="text-align: left;padding-right: 0px;">取样轴号：</div>
                                <div class="flex-content-span flex-1">{{info.rollernumber}}</div>
                            </div>
                             <div class="flex-content-container flex-3">
                               <div class="flex-content-label" style="min-width: 70px;padding-right: 0px;"></div>
                               <div class="flex-content-span flex-1"></div>
                            </div>
                        </div>
                        <div class="flex-container">
                          <div class="flex-content-container flex-1">
                            <div class="flex-content-label" style="text-align: right;padding-right: 0px;">取样人：</div>
                            <div class="flex-content-span flex-1">{{info.sampleuser}}</div>
                          </div>
                          <div class="flex-content-container flex-1">
                            <div class="flex-content-label" style="min-width: 50px;text-align: left;padding-right: 0;">取样位置：</div>
                            <div class="flex-content-span flex-1">{{info.locationname}}</div>
                          </div>
                        </div>

                        <div class="flex-container" v-if="info.determinegrade_tsd">
                          <div class="flex-content-container flex-3">
                            <div class="flex-content-label" style="min-width: 50px;text-align: left;padding-right: 0;color:#666;"> TSD判定：</div>
                            <span style="text-align:right;color: #666;">{{info.determineuser_tsd}}</span>
                          </div>
                          <div class="flex-content-container flex-2">
                            <span style="font-size:15px;color: #666;">{{info.determinetime_tsd}}</span>
                          </div>
                          <div class="flex-content-container flex-1" style="text-align:right;">
                            <span class="flex-strong" style="color: #ff0000;font-size:16px;">{{info.determinegrade_tsd}}</span>
                          </div>
                        </div>
                      </div>       
                    <!-- </div> -->
                  </div>
                </div>
              </li>
            </ul>
          </div>
      </div>
</div>

  </section>
</template>

<script>
    export default {
      name: "samplingHis",
      data(){
        return{
          paraInfo:{ddh:"",wph:"",scxtwph:"" ,scxtwpmc:""},
          sampleList:[]
        }
      },
      methods:{
        updsample(sampleno){
          var v=this;
          var li=document.getElementById(sampleno);
          setTimeout(function() {
                mui.swipeoutClose(li);
          }, 0);
          v.paraInfo.sampleno=sampleno;
          v.$router.push({"name":"samplingUpdate",params: jsonPara(v.paraInfo)});
        },
        determine(info){
          var v=this;
          var li=document.getElementById(info.sampleno);
          setTimeout(function() {
                mui.swipeoutClose(li);
          }, 0);
          v.paraInfo.sampleno=info.sampleno;
          v.paraInfo.determineuserflg=info.determineuserflg;
          v.$router.push({"name":"samplingDetermine",params: jsonPara(v.paraInfo)});
        },
        delsample(sampleno){
          var v=this;
          var li=document.getElementById(sampleno);
          mui.confirm('是否删除该取样？', '系统消息', ['确认', '取消'], function(e) {
            if(e.index==0){
              v.nyy.doPost("/Sample/deleteSample",{sampleno:sampleno}, 
                function(result){
                  if(result.status){
                    v.query();
                  } else {
                    mui.toast(result.message);
                    return;
                  }
                }
              );
            }
            setTimeout(function() {
                mui.swipeoutClose(li);
            }, 0);
          });
        },
        query(){
          var v=this;
          v.nyy.doPost("/Sample/getSampleList",v.paraInfo, 
            function(result){
              if(result.status){
                 v.sampleList=result.data.infoLst;
              }else {
                mui.toast(result.message);
                return;
              }
            }
          );
        }
      },
      activated() {
        var v=this;
        v.paraInfo = getJsonPara(v.$route);
        v.query();
      }
    }
</script>

<style scoped>
  @import "../../static/css/sampling.css";
  @import "../../static/css/samplinghistory.css";
</style>



// WEBPACK FOOTER //
// src/components/samplingHis.vue